export function wordSweepProgress(now, start, end) {
    if (!Number.isFinite(now) || !Number.isFinite(start) || !Number.isFinite(end) || end <= start)
        return 0;
    return Math.min(1, Math.max(0, (now - start) / (end - start)));
}

/** Resolve a paint end so the overlay never gets end <= start. */
export function resolveWordEnd(word, nextWord, lineEnd, minimumSpan = 0.08) {
    const start = Number(word?.startTime ?? word?.stringTime);
    let end = Number(word?.endTime);
    if (!Number.isFinite(end) && nextWord)
        end = Number(nextWord.startTime ?? nextWord.stringTime);
    if (!Number.isFinite(end))
        end = Number(lineEnd);
    if (!Number.isFinite(start))
        return end;
    if (!Number.isFinite(end) || end <= start)
        return start + minimumSpan;
    return end;
}
